/* Toggle footer accordion on / off based on screen width */

let footerAccordion = document.querySelector('.js-footer-accordion');

function checkFooterAccordion() {
  const breakpoint = 599;
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const showAccordion = width <= breakpoint;
  const elementIsAccordion = footerAccordion.classList.contains('is-accordion');

  const makeAccordion = showAccordion && !elementIsAccordion;
  const removeAccordion = !showAccordion && elementIsAccordion;

  if (makeAccordion || removeAccordion) {
    const items = footerAccordion.getElementsByClassName('js-accordion-item');
    for (let i=0;i<items.length;i++) {
      const content = items[i].getElementsByClassName('js-accordion-content');
      const button = items[i].getElementsByClassName('js-accordion-heading');

      if (content.length && button.length) {
        if (makeAccordion) {
          button[0].disabled = false;

          if (content[0].offsetParent === null) {
            // Content is hidden
            button[0].setAttribute('aria-expanded', 'false');
            content[0].setAttribute('aria-hidden', 'true');
            content[0].classList.remove('is-open');
          } else {
            // Content is visible
            button[0].setAttribute('aria-expanded', 'true');
            content[0].setAttribute('aria-hidden', 'false');
            content[0].classList.add('is-open');
          }
        } else if (removeAccordion) {
          // Content is always visible
          button[0].disabled = true;
          button[0].setAttribute('aria-expanded', 'true');
          content[0].setAttribute('aria-hidden', 'false');
        }
      }
    }

    if (makeAccordion) {
      footerAccordion.classList.add('is-accordion');
    } else if (removeAccordion) {
      footerAccordion.classList.remove('is-accordion');
    }
  }
}

function init() {
  checkFooterAccordion();

  window.addEventListener('resize', () => {
    checkFooterAccordion();
  });
}

export default {
  init
}
